import { useState, useEffect } from "react";
import { useParams } from "react-router";
import { generatePath, useNavigate } from "react-router-dom";

import { Button, Grid, Stack, Typography } from "@mui/material";
import { ArrowBack, CreateOutlined } from "@mui/icons-material";

import mayorService from "../../../../../services/mayorService";
import { AdminRoutesConfig, CommonRoutesConfig } from "./../../../../RoutesConfig";
import SectionPreview from "../../../../../common/components/SectionPreview";
import { translate } from "../../../../../common/utils/formatters";
import { MayorPreviewDto } from "../../../../../interfaces/admin/Mayor";

export default function Preview() {
  const { id: paramsId } = useParams();
  const mayorId: number = parseInt(paramsId as string);
  const navigate = useNavigate();
  const [mayor, setMayor] = useState<MayorPreviewDto>();

  useEffect(() => {
    if (isNaN(mayorId)) {
      navigate(CommonRoutesConfig.NotFound.Path, { replace: true });
    }

    (async () => {
      await mayorService.getMayorAsync(mayorId).then(({ data: mayor }) => setMayor(mayor));
    })();
  }, []);

  const handleEdit = () => {
    navigate(generatePath(AdminRoutesConfig.Mayor.Edit.Path, { id: mayorId.toString() }));
  };

  return (
    <Stack spacing={3}>
      <Stack direction="row" justifyContent="space-between">
        <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)}>
          Назад
        </Button>
        <Stack direction="row" spacing={1}>
          <Button startIcon={<CreateOutlined />} onClick={() => handleEdit()}>
            Редактирай
          </Button>
        </Stack>
      </Stack>
      <Stack spacing={3}>
        <SectionPreview title="Лични данни">
          <Stack>
            <Grid container rowSpacing={2}>
              <Grid item xs={12} md={6}>
                <Typography>Име</Typography>
                <Typography>
                  <strong>{mayor?.name}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} />
              <Grid item xs={12} md={6}>
                <Typography>Населено място</Typography>
                <Typography>
                  <strong>{mayor?.settlement.name}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} />
              <Grid item xs={12} md={6}>
                <Typography>Телефон</Typography>
                <Typography>
                  <strong>{mayor?.phone}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography>Електронна поща</Typography>
                <Typography>
                  <strong>{mayor?.email}</strong>
                </Typography>
              </Grid>
            </Grid>
          </Stack>
        </SectionPreview>
        <SectionPreview title="Потребителски данни">
          <Stack spacing={3}>
            <Grid container>
              <Grid item xs={12} md={3}>
                <Typography>Потребител</Typography>
                <Typography>
                  <strong>{mayor?.username}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography>Парола</Typography>
                <Typography>
                  <strong>{mayor?.password}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography>Активен</Typography>
                <Typography>
                  <strong>{translate(!!mayor?.isActive)}</strong>
                </Typography>
              </Grid>
            </Grid>
          </Stack>
        </SectionPreview>
      </Stack>
    </Stack>
  );
}
